import { CommonApi } from '../../api/server';

export const arrayBufferToDataURL = (binary: BlobPart): Promise<string> =>
  new Promise(res => {
    const blob = new Blob([binary], { type: 'application/octet-binary' });
    const reader = new FileReader();
    reader.onload = evt => {
      const target = evt?.target;
      if (!target) {
        return;
      }
      res(target.result as string);
    };
    reader.readAsDataURL(blob);
  });

function toApiPath(url: string): string {
  if (url.startsWith('/api')) {
    return url.slice(4);
  }
  return url;
}

export function fetchProtectedImageAsDataUrl(url: string | null | undefined): Promise<string | null> {
  if (!url) {
    return Promise.resolve(null);
  }
  if (url.startsWith('data:')) {
    return Promise.resolve(url);
  }

  return CommonApi.getBinary(toApiPath(url))
    .then(buffer => arrayBufferToDataURL(buffer))
    .catch(() => null);
}
